import { useState } from 'react'

import { CreateLocationRequestDTO } from '@/core/api/dtos/request/location/create'
import { UpdateLocationRequestDTO } from '@/core/api/dtos/request/location/update'
import { Location } from '@/core/api/entities/location'
import { useAccountConfig } from '@/core/hooks/useAccountConfig'
import { useCreateLocation } from '@/core/hooks/useLocation'
import { useTranslation } from '@/core/i18n/useTranslation'
import { useNotificationContext } from '@/shared/context/NotificationProvider'

export const useLocationCreate = (onSuccess?: () => void) => {
	const { t } = useTranslation('common')
	const [isModalVisible, setIsModalVisible] = useState(false)

	const { showNotification } = useNotificationContext()

	const { mutate: createLocation, isPending: isCreating } = useCreateLocation({
		config: useAccountConfig({}),
		options: {
			onSuccess: (location: Location) => {
				showNotification({
					type: 'success',
					message: t('entities.location.create.success.title'),
					description: t('entities.location.create.success.description', {
						name: location?.name || '',
					}),
				})
				closeCreateModal()
				onSuccess?.()
			},
			onError: () => {
				showNotification({
					type: 'error',
					message: t('entities.location.create.error.title'),
					description: t('entities.location.create.error.description'),
				})
			},
		},
	})

	const openCreateModal = () => {
		setIsModalVisible(true)
	}

	const closeCreateModal = () => {
		setIsModalVisible(false)
	}

	const handleCreateLocation = (
		data: CreateLocationRequestDTO | UpdateLocationRequestDTO
	) => {
		createLocation(data as CreateLocationRequestDTO)
	}

	return {
		isModalVisible,
		isCreating,
		openCreateModal,
		closeCreateModal,
		handleCreateLocation,
	}
}
